const GameCollectionFieldNameList =[
  "user", "careerID", "homeID", "healthInsInd", "roommates", "furnitureID", "carID", "carAge",
  "carYear", "startingCash", "currentCash", "startGameDate", "currentGameDate", "gameNbrMonths",
  "nbrMonthsNegative", "nbrMonthsMoodNegative", "homeType", "carType", "nbrYearsCollege",
  "nbrMonthsInJob", "pending.jobStartDate", "Job Salary"

];

export default GameCollectionFieldNameList